import React from 'react';
import {Canvas} from '@react-three/fiber';
import {Center} from '@react-three/drei';

import Shirt from './Shirt';
import Backdrop from './Backdrop';
import CameraRig from './CameraRig';

const CanvasModel: React.FC = () => {
    return (
        <Canvas
            shadows
            camera={{position: [0, 0, 5], fov: 25}} // Adjust the camera position if needed
            gl={{preserveDrawingBuffer: true}}
            className='h-full w-full max-w-full transition-all ease-in'>
            <ambientLight intensity={0.5} />
            <CameraRig>
                <Backdrop />
                {/*<Center>*/}
                <Shirt position={[0, 0, 0]} tshirtAsset='tshirt-assets/shirt_baked_collapsed.glb' />
                {/* Position the first T-shirt to the left */}
                <Shirt position={[-0.8, 0, 0]} tshirtAsset='tshirt-assets/shirt_baked_collapsed.glb' />{' '}
                {/* Position the second T-shirt to the right */}
                {/*</Center>*/}
            </CameraRig>
        </Canvas>
    );
};

export default CanvasModel;
